// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// // import { getCouponDetails, redeemCoupon } from '../services/couponService';
// import axios from 'axios';

// function CouponRedemptionPage() {
//   const { couponId } = useParams();
//   const [coupon, setCoupon] = useState(null);

//   useEffect(() => {
//     const fetchCouponDetails = async () => {
//       const data = await axios.get(
//         `/api/restaurants/${couponId}`
//         // headers: { Authorization: `Bearer ${token}` },
//       );
//       setCoupon(data);
//     };

//     fetchCouponDetails();
//   }, [couponId]);

//   const handleRedeem = async () => {
//     try {
//       // const token = localStorage.getItem('ownerToken');
//       await axios.post(
//         `/api/restaurants/redeem/${couponId}`,
//         {}
//         // headers: { Authorization: `Bearer ${token}` },
//       );
//       // await redeemCoupon(couponId);
//       alert('Coupon redeemed successfully!');
//     } catch (error) {
//       alert('Failed to redeem coupon');
//     }
//   };

//   if (!coupon) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div>
//       <h1>Coupon Details</h1>
//       {coupon.imageUrl && <img src={coupon.imageUrl} alt='Coupon' />}
//       <p>{coupon.description}</p>
//       <p>
//         <b>Code:</b> {coupon.code}
//       </p>
//       {coupon.qrCodeUrl && <img src={coupon.qrCodeUrl} alt='QR Code' />}
//       <button onClick={handleRedeem} disabled={coupon.isRedeemed}>
//         {coupon.isRedeemed ? 'Already Redeemed' : 'Redeem Coupon'}
//       </button>
//     </div>
//   );
// }

// export default CouponRedemptionPage;
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import QRCode from 'qrcode.react';
import { FaTicketAlt } from 'react-icons/fa';
import api from '../../services/api';
const CouponRedemptionPage = () => {
  const { couponId } = useParams(); // Assume the coupon ID is passed in the URL
  const [redeemStatus, setRedeemStatus] = useState(null); // For displaying success or error messages
  const [loading, setLoading] = useState(true); // Start with loading as true
  const [coupon, setCoupon] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCoupon = async () => {
      try {
        const response = await api.get(`/restaurants/page/${couponId}`);
        console.log(response.data);
        setCoupon(response.data);
      } catch (error) {
        setError('Failed to load coupon details.');
      } finally {
        setLoading(false);
      }
    };

    fetchCoupon();
  }, [couponId]);

  // const redeemCoupon = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await api.post(`/restaurants/redeem/${couponId}`);
  //     console.log(response);
  //     if (response.status == 200) {
  //       setRedeemStatus('Coupon redeemed successfully!');
  //     } else {
  //       setRedeemStatus('Failed to redeem coupon.');
  //     }
  //   } catch (error) {
  //     setRedeemStatus(
  //       error.response?.data?.message || 'Error redeeming coupon.'
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const redeemCoupon = async () => {
    setLoading(true);
    try {
      const response = await api.post(`/restaurants/redeem/${couponId}`);
      console.log(response);
      if (response.status === 200) {
        setRedeemStatus('Coupon redeemed successfully!');
        // Update the coupon state to reflect the redeemed status
        setCoupon((prevCoupon) => ({
          ...prevCoupon,
          isRedeemed: true, // Assuming the backend sends a 200 status on successful redemption
        }));
      } else {
        setRedeemStatus('Failed to redeem coupon.');
      }
    } catch (error) {
      setRedeemStatus(
        error.response?.data?.message || 'Error redeeming coupon.'
      );
    } finally {
      setLoading(false);
    }
  };

  const navigateToVerifyPage = () => {
    // Navigate to the verification page
    navigate(`/verify-redeem/${couponId}`);
  };

  if (loading)
    return (
      <div className='flex justify-center items-center'>
        <div className='animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500'></div>
      </div>
    ); // Show loading state
  if (error)
    return (
      // <div>{error}</div>; // Show error message
      <div className='max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-xl'>
        {/* {restaurant && (
        <h1 className='text-2xl font-bold mb-4 text-center'>
          {restaurant.name}
        </h1>
      )} */}
        <div className='text-center py-10'>
          <FaTicketAlt className='text-6xl text-gray-300 mx-auto mb-4' />
          <p className='text-xl text-gray-500'>{error}</p>
          <p className='text-gray-400 mt-2'>
            Coupon does not exist or has been removed
          </p>
        </div>
      </div>
    );

  return (
    <div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500'>
      <div className='p-6 mt-6 max-w-md mx-auto bg-white rounded-xl shadow-md space-y-4'>
        <h1 className='text-2xl font-bold text-gray-900'>Coupon Details</h1>
        <h1 className='text-md font-bold text-gray-500'>
          Please show this to one of the employees
        </h1>

        {/* {coupon.imageUrl && (
          <div className='mb-4'>
            <img
              src={coupon.imageUrl}
              alt='Coupon'
              className='w-full h-auto rounded-md'
            />
          </div>
        )} */}

        {/* <div className='mb-4'>
          <strong>Description:</strong>
          <p>{coupon.description}</p>
        </div> */}

        <div className='mb-4'>
          <strong>Message Content:</strong>
          <p>{coupon.messageContent}</p>
        </div>

        {/* {I want to add image uploaded when creating text message here.} */}
        {/* I want to add text message description here. */}

        <div className='mb-4'>
          <strong>Expiration Date:</strong>
          <p>
            {coupon.expirationDate
              ? new Date(coupon.expirationDate).toLocaleDateString()
              : 'No expiration date'}
          </p>
        </div>

        <div className='mb-4'>
          <strong>Verify using QR Code:</strong>
          <div>
            {
              coupon.qrCodeUrl && (
                <img
                  src={coupon.qrCodeUrl}
                  alt='QR Code'
                  className='w-42 h-42 mx-auto'
                />
              )
              // : (
              //   <QRCode value={window.location.href} size={128} />
              // )}
            }
          </div>
        </div>

        <div className='mb-4'>
          <strong>Redeem Status:</strong>
          <p>{coupon.isRedeemed ? 'Redeemed' : 'Not Redeemed'}</p>
        </div>
        {redeemStatus && (
          <div
            className={`p-4 mb-4 text-white ${
              redeemStatus.includes('successfully')
                ? 'bg-green-500'
                : 'bg-red-500'
            }`}
          >
            {redeemStatus}
          </div>
        )}

        {/* <button
          onClick={redeemCoupon}
          disabled={loading}
          className={`w-full py-2 px-4 text-white font-bold rounded-lg ${
            loading ? 'bg-gray-500' : 'bg-indigo-600 hover:bg-indigo-700'
          }`}
        >
          {loading ? 'Redeeming...' : 'Redeem Coupon'}
        </button> */}
        {!coupon.isRedeemed && (
          <button
            onClick={navigateToVerifyPage}
            disabled={loading}
            className={`w-full py-2 px-4 text-white font-bold rounded-lg ${
              loading ? 'bg-gray-500' : 'bg-indigo-600 hover:bg-indigo-700'
            }`}
          >
            {loading ? 'Loading...' : 'Redeem (Employee Only)'}
          </button>
        )}
      </div>

      {/* <div className='flex justify-center items-center h-screen'>
        <div className='bg-white shadow-md rounded-lg p-8 w-full max-w-md'>
          <h1 className='text-2xl font-bold mb-4'>Redeem Your Coupon</h1>

          {redeemStatus && (
            <div
              className={`p-4 mb-4 text-white ${
                redeemStatus.includes('successfully')
                  ? 'bg-green-500'
                  : 'bg-red-500'
              }`}
            >
              {redeemStatus}
            </div>
          )}

          <button
            onClick={redeemCoupon}
            disabled={loading}
            className={`w-full py-2 px-4 text-white font-bold rounded-lg ${
              loading ? 'bg-gray-500' : 'bg-indigo-600 hover:bg-indigo-700'
            }`}
          >
            {loading ? 'Redeeming...' : 'Redeem Coupon'}
          </button>
        </div> */}
      {/* </div> */}
    </div>
  );
};

export default CouponRedemptionPage;
